import React, { useEffect, useRef, useState } from "react";
import { Button } from "@chakra-ui/react";
import { useAppStore } from "../../../context/store";
import { Tooltip } from "../../ui/tooltip";
import { LuGitBranchPlus } from "react-icons/lu";
import { generateRoute } from "../../../utilies/route/Generate";
import { useMapObjects } from "../../../context/MapObjectsContext";
function GenerateRoute() {
  const viewerRef = useAppStore((s) => s.viewerRef);
  const { mapObjects } = useMapObjects();
  const editMode = useAppStore((s) => s.editMode);
  const userCanEditing = useAppStore((s) => s.userCanEditing);
  const userData = useAppStore((s) => s.userData);

  const setCanHightlightEntity = useAppStore.getState().setCanHightlightEntity;
  const setCanOpenInfobox = useAppStore.getState().setCanOpenInfobox;
  const setLayersApprovalGenerateRouteDialog = useAppStore.getState().setLayersApprovalGenerateRouteDialog;

  const generateRouteMode = useAppStore((s) => s.generateRouteMode);
  const setGenerateRouteMode = useAppStore((s) => s.setGenerateRouteMode);

  const [isShow, stIsShow] = useState(false);

  const stopRef = useRef(null);

  useEffect(() => {
    // Track required layer presence
    let hasLanelet = false;
    let hasMarkerLane = false;
    let hasVirtualLane = false;

    for (const key in mapObjects) {
      const fileName = mapObjects[key].file_name.toLowerCase().replace(/[-_ ]/g, "");
      // normalize case

      if (fileName.includes("lanelet")) {
        hasLanelet = true;
      }
      if (fileName.includes("lanemarker")) {
        hasMarkerLane = true;
      }
      if (fileName.includes("virtualline")) {
        hasVirtualLane = true;
      }

      if (hasLanelet && (hasMarkerLane || hasVirtualLane)) {
        break;
      }
    }

    const shouldShow = hasLanelet && (hasMarkerLane || hasVirtualLane);

    stIsShow(shouldShow && userCanEditing);
  }, [mapObjects, userCanEditing]);

  useEffect(() => {
    if (!isShow) {
      if (stopRef.current) {
        stopRef.current();
        stopRef.current = null;
      }

      setCanHightlightEntity(true);
      setCanOpenInfobox(true);
      setGenerateRouteMode(false);
    }
  }, [isShow]);

  useEffect(
    () => () => {
      if (stopRef.current) {
        stopRef.current();
        stopRef.current = null;
      }
      setGenerateRouteMode(false);
    },
    [],
  );

  // Handle keyboard
  useEffect(() => {
    // --- Handle all keyboard shortcuts for layer actions ---
    const handleKeyDown = (event) => {
      if (!isShow) return;
      if (editMode) return;
      if (event.shiftKey) {
        const key = event.key.toLowerCase();

        switch (key) {
          case "g":
            for (const key in mapObjects) {
              if (mapObjects[key].file_name.toLowerCase().includes("lanelet")) {
                toggleGenerateRoute(mapObjects[key]);
                break;
              }
            }

            break;
          default:
            break;
        }
      }
    };

    // Register event listener
    window.addEventListener("keydown", handleKeyDown);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [mapObjects, isShow, generateRouteMode, editMode]);

  const toggleGenerateRoute = () => {
    if (!generateRouteMode) {
      setCanHightlightEntity(false);
      setCanOpenInfobox(false);
      const { virtualDS, markerDS, turningDS, laneletDS, turningArcDS } = pickDataSources();

      stopRef.current = generateRoute({
        viewer: viewerRef.current,
        dataSource: laneletDS,
        virtualDS,
        markerDS,
        turningDS,
        turningArcDS,
        userData,
        onDone: ({ geojson, resetStyles, reason }) => {
          if (stopRef.current) {
            stopRef.current();
            stopRef.current = null;
          }

          setCanHightlightEntity(true);
          setCanOpenInfobox(true);

          setLayersApprovalGenerateRouteDialog({
            geojson,
            resetStyles,
          });
        },
        onAbort: (reason) => {
          setCanHightlightEntity(true);
          setCanOpenInfobox(true);
        },
        onEvent: (e) => {
          if (e?.type === "init") setGenerateRouteMode(true);
        },
        onFinally: () => {
          setCanHightlightEntity(true);
          setCanOpenInfobox(true);
          setGenerateRouteMode(false);
          if (stopRef.current) {
            stopRef.current();
            stopRef.current = null;
          }
        },
      });

      setGenerateRouteMode(true);
    } else {
      if (stopRef.current) {
        stopRef.current();
        stopRef.current = null;
      }

      setCanHightlightEntity(true);
      setCanOpenInfobox(true);
      setGenerateRouteMode(false);
    }
  };

  function pickDataSources() {
    let laneletDS = null;
    let virtualDS = null;
    let markerDS = null;
    let turningDS = null;
    let turningArcDS = null;

    for (const key in mapObjects) {
      const mo = mapObjects[key];

      if (mo?.dataSource && /lanelet/i.test(mo.file_name || "")) laneletDS = mo.dataSource;
      if (
        mo?.dataSource &&
        (mo.file_name || "")
          .replace(/[\s_-]/g, "")
          .toLowerCase()
          .includes("virtualline")
      ) {
        virtualDS = mo.dataSource;
      }

      if (
        mo?.dataSource &&
        (mo.file_name || "")
          .replace(/[\s_-]/g, "")
          .toLowerCase()
          .includes("lanemarker")
      ) {
        markerDS = mo.dataSource;
      }
      if (
        mo?.dataSource &&
        (mo.file_name || "")
          .replace(/[\s_-]/g, "")
          .toLowerCase()
          .includes("turningline")
      ) {
        turningDS = mo.dataSource;
      }
      if (
        mo?.dataSource &&
        (mo.file_name || "")
          .replace(/[\s_-]/g, "")
          .toLowerCase()
          .includes("turningarc")
      ) {
        turningArcDS = mo.dataSource;
      }
    }
    return { laneletDS, virtualDS, markerDS, turningDS, turningArcDS };
  }

  return (
    <>
      {isShow && (
        <Button
          disabled={editMode}
          variant="solid"
          p={0}
          opacity={1}
          bg={generateRouteMode ? "green" : "white"}
          color={generateRouteMode ? "white" : "MenuText"}
          colorPalette={generateRouteMode ? "green" : "white"}
          onClick={() => {
            toggleGenerateRoute();
          }}
        >
          <Tooltip content="Generate Route">
            <LuGitBranchPlus />
          </Tooltip>
        </Button>
      )}
    </>
  );
}

export default GenerateRoute;
